import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { announcements } from '../../data/store';
import { easeOut } from '../../utils/motion';
export function AnnouncementBar() {
  const [index, setIndex] = useState(0);
  const reduce = useReducedMotion();
  useEffect(() => {
    const id = window.setInterval(() => setIndex(i => (i + 1) % announcements.length), 4500);
    return () => window.clearInterval(id);
  }, []);
  return <div className="bg-ink text-paper" data-id="element-366" data-mp="vd21eyni8w4l">
      <div className="relative mx-auto flex h-9 max-w-[1440px] items-center justify-center overflow-hidden px-5 text-xs tracking-wide" data-id="element-367" data-mp="ve3lttqeuuyz">
        <AnimatePresence mode="wait" initial={false} data-id="element-368" data-mp="15brl8wyyoqnh">
          <motion.p key={index} initial={reduce ? {
          opacity: 0
        } : {
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={reduce ? {
          opacity: 0
        } : {
          opacity: 0,
          y: -8
        }} transition={{
          duration: 0.22,
          ease: easeOut
        }} aria-live="polite" data-id="element-369" data-mp="15dcemj9ji3jr">
            {announcements[index]}
          </motion.p>
        </AnimatePresence>
      </div>
    </div>;
}